import groq from 'groq';

export const blockPartnerLogoFields = groq``;